import {
  IAmplifyConfigData,
  IAmplifyConfigDataNewSetUp,
  IAmplifyGoConfigData,
} from "../../../../config";

enum configureTypes {
  LAMBDA = "lambda",
  FAST = "fast",
  GO = "go",
}

export type IAmplifyProvider = ReturnType<typeof AmplifyProviderFactory>;

export const AmplifyProviderFactory = ({
  amplify,
  auth,
  amplifyConfig,
}: {
  amplify: {
    configure: (config: Record<string, string>) => {};
  };
  auth: IAuthLib;
  amplifyConfig: {
    amplifyConfigData: IAmplifyConfigData;
    amplifyConfigDataNewSetUp: IAmplifyConfigDataNewSetUp;
    amplifyGoConfigData: IAmplifyGoConfigData;
  };
}) => {
  const { amplifyConfigDataNewSetUp, amplifyConfigData, amplifyGoConfigData } =
    amplifyConfig;
  const amplifyConfigure = (type = "fast") => {
    let configToImplement = {};
    switch (type) {
      case configureTypes.FAST:
        configToImplement = amplifyConfigDataNewSetUp;
        break;
      case configureTypes.GO:
        configToImplement = amplifyGoConfigData;
        break;
      case configureTypes.LAMBDA:
        configToImplement = amplifyConfigData;
        break;
      default:
        configToImplement = amplifyConfigDataNewSetUp;
        break;
    }

    amplify.configure(configToImplement);
    return auth.configure(configToImplement);
  };

  return {
    amplifyConfigure,
    auth,
  };
};
